import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VoucherPDFRes;
export const VoucherPDFTodo = createAsyncThunk('VoucherPDF', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'pdf_voucher_printing',
            data: {
                "vinvoice_code": data,
                "fromVoucher": data,
                "toVoucher": data,
                "vcode": data,
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
            },
            headers: { "Content-Type": "application/json" }
        })
        return VoucherPDFRes = res.data

    } catch (error) {
        return VoucherPDFRes = error.response.data
    }
})


